"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Autocomplete = _interopRequireDefault(require("./Autocomplete"));

var _excluded = ["field", "form", "options"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SimpleAutocomplete = function SimpleAutocomplete(_ref) {
  var field = _ref.field,
      form = _ref.form,
      options = _ref.options,
      props = _objectWithoutProperties(_ref, _excluded);

  var getSimpleOptions = function getSimpleOptions(_ref2) {
    var setOptions = _ref2.setOptions,
        setLoading = _ref2.setLoading,
        active = _ref2.active;

    if (active) {
      setOptions(options);
      setLoading(false);
    }
  };

  return /*#__PURE__*/_react["default"].createElement(_Autocomplete["default"], _extends({
    fetchOptions: getSimpleOptions,
    getOptionLabel: getSimpleOptionLabel,
    getOptionSelected: getSimpleOptionSelected,
    renderOption: renderSimpleOption,
    field: field,
    form: form
  }, props));
};

var _default = SimpleAutocomplete; //----- Simple Autocomplete

exports["default"] = _default;

var getSimpleOptionSelected = function getSimpleOptionSelected(option, value) {
  return option.label === value.label;
};

var getSimpleOptionLabel = function getSimpleOptionLabel(option) {
  return option && !Array.isArray(option) ? option.label : "";
};

var renderSimpleOption = function renderSimpleOption(option) {
  return option && /*#__PURE__*/_react["default"].createElement("div", {
    key: option.value
  }, option.label) || "";
}; //----- Simple Autocomplete


SimpleAutocomplete.propTypes = {
  /**
   * The label content.
   */
  label: _propTypes["default"].string,

  /**
   * Formik field
   */
  field: _propTypes["default"].shape({
    name: _propTypes["default"].string.isRequired,
    value: _propTypes["default"].any
  }).isRequired,

  /**
   * Formik form
   */
  form: _propTypes["default"].shape({
    touched: _propTypes["default"].object,
    errors: _propTypes["default"].object,
    setFieldValue: _propTypes["default"].func.isRequired
  }).isRequired,

  /**
   * simple options [{label, value}]
   */
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string.isRequired,
    value: _propTypes["default"].any.isRequired
  })).isRequired
};